const BASE = process.env.REACT_APP_BACKEND_URL;

const visitorId = () => {
  try {
    let id = localStorage.getItem("gb_vid");
    if (!id) { id = crypto.randomUUID(); localStorage.setItem("gb_vid", id); }
    return id;
  } catch { return "anonymous"; }
};

export const trackClick = (placement, product = "joint-genesis") => {
  if (!BASE) return;
  fetch(`${BASE}/api/clicks`, {
    method: "POST",
    keepalive: true,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ placement, product, visitor_id: visitorId() }),
  }).catch(() => {});
};
